export default "__VITE_ASSET__DPpa6kyd__"